module.exports = __webpack_public_path__ + "static/media/export-icon.189a7acc.svg";